import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M24 45C12.402 45 3 35.598 3 24C3 12.402 12.402 3 24 3C35.598 3 45 12.402 45 24C45 35.598 35.598 45 24 45ZM24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M32.909 14.909C32.8878 14.9302 32.8678 14.9527 32.8493 14.9763L22.4322 28.2502L16.1516 21.9697C15.2729 21.091 13.8483 21.091 12.9696 21.9697C12.091 22.8483 12.091 24.273 12.9696 25.1516L20.909 33.091C21.7877 33.9697 23.2123 33.9697 24.091 33.091C24.1105 33.0714 24.129 33.0508 24.1463 33.0292L36.1229 18.0584C36.9695 17.1774 36.9589 15.7769 36.091 14.909C35.2123 14.0303 33.7877 14.0303 32.909 14.909Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}